import React from 'react';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import ProductAvailability from '../../../../components/product-availability/product-availability';
import {
  MapMarkerAltSolidIcon,
  ShopSolidIcon
} from '../../../../shared/icons/icons';

import { useMyStore } from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { getPdpMultiStoreDataLayerValues } from '../../utils/product-details-page-analytics-utils';

import {
  BundleData,
  ProductData,
  StockData
} from '../../../../shared/types/graphql-types';

import './store-availability-options.scss';

// Remove when OW-17564 is merged
interface ProductDataWithNearbyStoreStock extends ProductData {
  nearByStoreStock: StockData;
}

interface StoreAvailabilityOptionsProps {
  myStoreCode?: string | null;
  onClickStore: (storeCode: string) => void;
  prebuiltPackage?: BundleData;
  product: ProductDataWithNearbyStoreStock;
  quantity?: number;
  rearProduct?: ProductData | null;
  rearQuantity?: number;
  selectedStoreCode?: string | null;
}

function StoreAvailabilityOptions(props: StoreAvailabilityOptionsProps) {
  const {
    myStoreCode,
    onClickStore,
    prebuiltPackage,
    product,
    quantity,
    rearProduct,
    rearQuantity,
    selectedStoreCode
  } = props;

  const nearbyStoreCode = product?.nearByStoreStock?.storeCode;
  const { myStore } = useMyStore();

  if (!myStoreCode) return null;

  function onClickSelectedStoreAnalytics(storeCode) {
    const payload = getPdpMultiStoreDataLayerValues(
      product,
      myStore?.nearByStores,
      myStoreCode,
      storeCode
    );
    trackAction('pdp_multistore_select_store', {
      ...payload
    });
  }

  function handleOnClickPreferredStore() {
    myStoreCode && onClickStore(myStoreCode);
    if (selectedStoreCode !== myStoreCode) {
      onClickSelectedStoreAnalytics(myStoreCode);
    }
  }

  function handleOnClickNearByStore() {
    nearbyStoreCode && onClickStore(nearbyStoreCode);
    if (selectedStoreCode !== nearbyStoreCode) {
      onClickSelectedStoreAnalytics(nearbyStoreCode);
    }
  }

  return (
    <div
      styleName={`container ${
        !nearbyStoreCode ? 'container--single-column' : ''
      }`}
    >
      <Button
        onClick={handleOnClickPreferredStore}
        styleName={`option ${
          selectedStoreCode === myStoreCode ? 'option--selected' : ''
        }`}
      >
        <MapMarkerAltSolidIcon styleName="my-store-icon" />

        <Typography styleName="option-title" tag="div" weight="heavy">
          My Preferred Store
        </Typography>

        <ProductAvailability
          prebuiltPackage={prebuiltPackage}
          product={product}
          quantity={quantity}
          rearProduct={rearProduct}
          rearQuantity={rearQuantity}
        />
      </Button>

      {nearbyStoreCode && (
        <Button
          onClick={handleOnClickNearByStore}
          styleName={`option ${
            selectedStoreCode === nearbyStoreCode ? 'option--selected' : ''
          }`}
        >
          <ShopSolidIcon styleName="nearby-store-icon" />

          <Typography styleName="option-title" tag="div" weight="heavy">
            Nearby Store
          </Typography>

          <ProductAvailability
            prebuiltPackage={prebuiltPackage}
            product={product}
            quantity={quantity}
            rearProduct={rearProduct}
            rearQuantity={rearQuantity}
            shouldShowNearbyStoreStock
          />
        </Button>
      )}
    </div>
  );
}

export default StoreAvailabilityOptions;
